import styled from 'styled-components'

export const Filtro = styled.div`
  display: grid;
  gap: 16px;
`

export const Label = styled.label`
  font-weight: 400;
  font-size: 20px;
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.cor9};
  margin: 0;
`
